import { useFavicon } from '@vueuse/core'

export function useMeta() {
  function setThemeColor(color: string) {
    let themeColorMeta = document.querySelector('meta[name="theme-color"]')

    if (!themeColorMeta) {
      themeColorMeta = document.createElement('meta')
      themeColorMeta.setAttribute('name', 'theme-color')
      document.head.appendChild(themeColorMeta)
    }

    themeColorMeta.setAttribute('content', color)
  }

  function setOgImage(imageUrl: string) {
    let ogImageMeta = document.querySelector('meta[property="og:image"]')

    if (!ogImageMeta) {
      ogImageMeta = document.createElement('meta')
      ogImageMeta.setAttribute('property', 'og:image')
      document.head.appendChild(ogImageMeta)
    }

    ogImageMeta.setAttribute('content', imageUrl)
  }

  function setFavicon(faviconUrl: string) {
    useFavicon(faviconUrl)
  }

  return {
    setThemeColor,
    setOgImage,
    setFavicon,
  }
}
